export default {
  mutateSupportFormLoadingState(state, loading) {
    state.loading = loading;
  },
  mutateSupportFormLoadingProgressState(state, loadingProgress) {
    state.loadingProgress = loadingProgress;
  },
};
